const config = {
API_BASE_URL: "https://orca-helpdesk.online/api"

};

export default config;


// config.js